import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import Layout from '../components/Layout'
import Seo from '../components/Seo'
import Loop from '../components/Loop'
import FeaturedPostsSlider from '../components/FeaturedPostsSlider'

const BlogIndex = ({ useGrid }) => {
	return (
		<Layout>
			<Seo keywords={[`blog`, `gatsby`, `javascript`, `react`]} />
			<FeaturedPostsSlider />
			<div className={`post-list-wrap`}>
				<Loop />
			</div>
		</Layout>
	)
}

const blogIndexQuery = graphql`
	{
		allSite {
			nodes {
				siteMetadata {
					themeOptions {
						site {
							useGrid
						}
					}
				}
			}
		}
	}
`

function StaticBlogIndex() {
	return (
		<StaticQuery
			query={blogIndexQuery}
			render={data => (
				<BlogIndex
					useGrid={data.allSite.nodes[0].siteMetadata.themeOptions.site.useGrid}
				/>
			)}
		/>
	)
}

export default StaticBlogIndex
